import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import LogoutView from './components/Logout.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import UsuarioView from './components/views/Usuario.vue'
import ManutencaoView from './components/views/Manutencao.vue'
import GraficosView from './components/views/Graficos.vue'
import GraficosMaterialView from './components/views/GraficosMaterial.vue'
import GraficosAcumuladosView from './components/views/GraficosAcumulados.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Principal',
        meta: {
          namePtbr: 'Principal',
          nameDe: 'Main',
          nameEn: 'Home',
          nameEs: 'Principal',
          descriptionPtbr: 'Monitoramento do Biodigestor Ronchi',
          descriptionDe: 'Ronchi Biodigester Überwachung',
          descriptionEn: 'Ronchi Biodigester Monitoring',
          descriptionEs: 'Monitoreo de Biodigestores Ronchi',
          requiresAuth: true
        }
      },
      {
        path: 'usuario',
        alias: '',
        component: UsuarioView,
        name: 'Usuário',
        meta: {
          namePtbr: 'Usuário',
          nameDe: 'Benutzer',
          nameEn: 'User',
          nameEs: 'Usuario',
          descriptionPtbr: 'Edição dos dados de Usuário',
          descriptionDe: 'Benutzerdaten bearbeiten',
          descriptionEn: 'Editing User Data',
          descriptionEs: 'Edición de datos de usuario',
          requiresAuth: true
        }
      },
      {
        path: 'manutencao',
        alias: '',
        component: ManutencaoView,
        name: 'Manutenção',
        meta: {
          namePtbr: 'Manutenção',
          nameDe: 'Wartung',
          nameEn: 'Maintenance',
          nameEs: 'Mantenimiento',
          descriptionPtbr: 'Monitoramento de todas variáveis do Biodigestor Ronchi',
          descriptionDe: 'Überwachung aller Variablen von Ronchi Biodigester',
          descriptionEn: 'Monitoring of all Ronchi Biodigester variables',
          descriptionEs: 'Monitoreo de todas las variables de Biodigestores Ronchi',
          requiresAuth: true
        }
      },
      {
        path: 'graficos',
        alias: '',
        component: GraficosView,
        name: 'Gráficos',
        meta: {
          namePtbr: 'Gráficos',
          nameDe: 'Diagramme',
          nameEn: 'Charts',
          nameEs: 'Gráficos',
          descriptionPtbr: 'Relatório das variáveis do Biodigestor Ronchi',
          descriptionDe: 'Grafik der Variablen des Biodigestor Ronchi',
          descriptionEn: 'Graph of the variables of the Biodigestor Ronchi',
          descriptionEs: 'Gráfico de las variables del Biodigestor Ronchi.',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-material',
        alias: '',
        component: GraficosMaterialView,
        name: 'Gráficos Material',
        meta: {
          namePtbr: 'Gráficos',
          nameDe: 'Diagramme',
          nameEn: 'Charts',
          nameEs: 'Gráficos',
          descriptionPtbr: 'Valores de análise do material do Biodigestor Ronchi',
          descriptionDe: 'Analysewerte des Materials des Biodigestor Ronchi',
          descriptionEn: 'Values ​​of analysis of the material of the Biodigestor Ronchi',
          descriptionEs: 'Valores de análisis del material del Biodigestor Ronchi.',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-acumulados',
        alias: '',
        component: GraficosAcumuladosView,
        name: 'Gráficos Acumulados',
        meta: {
          namePtbr: 'Gráficos',
          nameDe: 'Diagramme',
          nameEn: 'Charts',
          nameEs: 'Gráficos',
          descriptionPtbr: 'Crescimento diário dos valores acumulados.',
          descriptionDe: 'Tägliches Wachstum der akkumulierten Werte',
          descriptionEn: 'Daily growth of accumulated values',
          descriptionEs: 'Crecimiento diario de los valores acumulados.',
          requiresAuth: true
        }
      }
    ]
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js